import { ChainId, Token, WETH9 } from '@pancakeswap/sdk'
import { USDC_FC, USDT_FC } from './common'

export const frenchainTokens = {
  wfren: WETH9[ChainId.FRENCHAIN],
  usdc: USDC_FC,
  cake: new Token(
    ChainId.FRENCHAIN,
    '0x0E7a1Bd7C15B871c25F44a2d2A438174bB13026C',
    18,
    'WOJK',
    'WojakToken',
    'https://www.wojak.fi/',
  ),
  wojk: new Token(
    ChainId.FRENCHAIN,
    '0x0E7a1Bd7C15B871c25F44a2d2A438174bB13026C',
    18,
    'WOJKfren',
    'WojakToken',
    'https://www.wojak.fi/',
  ),
  eth: new Token(
    ChainId.FRENCHAIN,
    '0x8fc9b7Fb35386d8A2a24257D90d527b45B336640',
    18,
    'WETH',
    'FrenBridge WETH',
    'https://www.frenchain.app/',
  ),
  syrup: new Token(
    ChainId.FRENCHAIN,
    '0x009cF7bC57584b7998236eff51b98A168DceA9B0',
    18,
    'SYRUP',
    'SyrupBar Token',
    'https://pancakeswap.finance/',
  ),
}
